import React from 'react';


interface ImageSitemapData {
  loc: string;
  images: Array<{
    src: string;
    caption?: string;
    title?: string;
    license?: string;
    geoLocation?: string;
  }>;
}

export function generateImageSitemap(): string {
  const sitemapData: ImageSitemapData[] = [
    {
      loc: 'https://xxlservices.com/',
      images: [
        {
          src: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&q=80&w=2000',
          caption: 'Professional IT support services for Treasure Valley businesses',
          title: 'IT Support Meridian Idaho - XXL IT Services',
          geoLocation: 'Meridian, Idaho'
        }
      ]
    },
    {
      loc: 'https://xxlservices.com/services/it-support',
      images: [
        {
          src: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=2000',
          caption: '24/7 IT support and monitoring services for businesses',
          title: 'IT Support Services Meridian - XXL IT Services',
          geoLocation: 'Meridian, Idaho'
        }
      ]
    },
    {
      loc: 'https://xxlservices.com/services/cybersecurity',
      images: [
        {
          src: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&q=80&w=2000',
          caption: 'Enterprise cybersecurity solutions for Idaho businesses',
          title: 'Cybersecurity Services Meridian - XXL IT Services',
          geoLocation: 'Meridian, Idaho'
        }
      ]
    },
    {
      loc: 'https://xxlservices.com/services/network-cabling-contractors',
      images: [
        {
          src: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&q=80&w=2000',
          caption: 'Professional network cabling installation in Treasure Valley',
          title: 'Network Cabling Contractors Meridian Boise - XXL IT Services',
          geoLocation: 'Treasure Valley, Idaho'
        }
      ]
    },
    {
      loc: 'https://xxlservices.com/location/boise',
      images: [
        {
          src: 'https://images.unsplash.com/photo-1555685812-4b943f1cb0eb?auto=format&fit=crop&q=80&w=2000',
          caption: 'IT services for Boise businesses and organizations',
          title: 'IT Services Boise Idaho - XXL IT Services',
          geoLocation: 'Boise, Idaho'
        }
      ]
    }
  ];

  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"
        xmlns:image="http://www.google.com/schemas/sitemap-image/1.1">
${sitemapData.map(page => `  <url>
    <loc>${page.loc}</loc>
${page.images.map(image => `    <image:image>
      <image:loc>${image.src}</image:loc>
      ${image.caption ? `<image:caption>${image.caption}</image:caption>` : ''}
      ${image.title ? `<image:title>${image.title}</image:title>` : ''}
      ${image.geoLocation ? `<image:geo_location>${image.geoLocation}</image:geo_location>` : ''}
    </image:image>`).join('\n')}
  </url>`).join('\n')}
</urlset>`;

  return xml;
}

// Component to inject image sitemap link in head
export function ImageSitemapLink() {
  React.useEffect(() => {
    // Check if image sitemap link already exists
    const existingLink = document.querySelector('link[rel="sitemap"][type="application/xml"][title="Image Sitemap"]');
    if (existingLink) return;

    // Create and inject image sitemap link
    const link = document.createElement('link');
    link.rel = 'sitemap';
    link.type = 'application/xml';
    link.title = 'Image Sitemap';
    link.href = '/image-sitemap.xml';
    document.head.appendChild(link);

    return () => {
      const linkElement = document.querySelector('link[rel="sitemap"][type="application/xml"][title="Image Sitemap"]');
      if (linkElement) {
        linkElement.remove();
      }
    };
  }, []);

  return null;
}

// Generate and save image sitemap
export async function saveImageSitemap() {
  const sitemap = generateImageSitemap();
  
  // In a real implementation, you would save this to public/image-sitemap.xml
  // Image sitemap generated successfully
  
  return sitemap;
}